// extracted by mini-css-extract-plugin
export var button = "_8o-0";
export var icon = "_8o-1";